import { ActionReducerMap } from '@ngrx/store';
import { orderHistoryChartsReducer } from './order-history-charts.reducer';
import { orderHistoryFetchReducer } from './order-history-fetch.reducer';
import { orderHistoryQuatationReducer } from './order-history-quotation.reducer';
import { CustomState } from '../order-history-state';

export const customReducers: ActionReducerMap<CustomState> = {
    charts: orderHistoryChartsReducer,
    fetch: orderHistoryFetchReducer,
    quotation: orderHistoryQuatationReducer
};